import {FiltersEnum} from 'filters-selections';

export const integrationFilterList = [
  FiltersEnum.IntegrationTypeSingle,
  FiltersEnum.IntegrationStatusMulti,
  FiltersEnum.AreasMultiAutocompleteExternalData,
  FiltersEnum.SchoolDistrictMulti,
  FiltersEnum.SchoolNameBasedOnAreaAndDistrict,
];
